export const Settings = {
  V1: {
    SettingRemoved: 'Settings.V1.SettingRemoved',
    SettingSet: 'Settings.V1.SettingSet'
  }
} as const

export type SettingRemovedSignalRPayload = {
  /** The setting-name identifier (e.g. `client.billing.defaultPaymentTerms`). */
  name: string
  /** The scope the override was removed from. */
  scopeLevel: 'global' | 'agency' | 'user'
  /** The agency node id when `scopeLevel === 'agency'`. Undefined otherwise. */
  agencyNodeId?: string
}

export type SettingSetSignalRPayload = {
  /** The setting-name identifier (e.g. `client.billing.invoicing.defaultCurrency`). */
  name: string
  /** The scope the override was assigned at. */
  scopeLevel: 'global' | 'agency' | 'user'
  /** The agency node id when `scopeLevel === 'agency'`. Undefined otherwise. */
  agencyNodeId?: string
}
